export const createTemplateSlice = set => ({
  template: null,
  setTemplate: value => set(() => ({ template: value })),

  templates: [],
  setTemplates: values => set(() => ({ templates: values })),

  templatesRef: [],
  setTemplatesRef: values => set(() => ({ templatesRef: values })),

  templatesFilter: { search: '', tags: [] },
  setTemplatesFilter: value =>
    set(state => ({ templatesFilter: { ...state.templatesFilter, ...value } })),
  resetTemplatesFilter: () =>
    set(() => ({ templatesFilter: { search: '', tags: [] } })),

  templateSortableActive: false,
  setTemplateSortableActive: value =>
    set(() => ({ templateSortableActive: value }))
});
